import { useState } from 'react';

const pressFeatures = [
  {
    outlet: 'Modern Ghana',
    headline: 'Ghanaian Math Teacher in NY Sets High Standards',
    url: 'https://www.modernghana.com/news/139363/ghanaian-math-teacher-in-ny-sets-high-standards.html',
    logo: 'MG',
    color: 'from-green-700 to-green-900',
    year: '2008',
  },
  {
    outlet: 'GhanaWeb',
    headline: 'Ghanaian Math Teacher Honoured in New York',
    url: 'https://www.ghanaweb.com/GhanaHomePage/NewsArchive/Ghanaian-Math-teacher-honoured-in-New-York-127388',
    logo: 'GW',
    color: 'from-red-700 to-red-900',
    year: '2009',
  },
  {
    outlet: 'GhanaWeb',
    headline: 'NY Ghanaian Best Math Teacher',
    url: 'https://www.ghanaweb.com/GhanaHomePage/NewsArchive/NY-Ghanaian-Best-Math-Teacher-141203',
    logo: 'GW',
    color: 'from-red-700 to-red-900',
    year: '2010',
  },
  {
    outlet: 'GhanaWeb',
    headline: 'NYC Honors Ghanaian Educator',
    url: 'https://www.ghanaweb.com/GhanaHomePage/NewsArchive/NYC-Honors-Ghanaian-126799',
    logo: 'GW',
    color: 'from-red-700 to-red-900',
    year: '2009',
  },
];

const awards = [
  {
    icon: 'ri-trophy-fill',
    label: "Chancellor's Honor Award",
    sub: 'NYC Department of Education',
    color: 'text-amber-500',
    bg: 'bg-amber-50',
    border: 'border-amber-200',
  },
  {
    icon: 'ri-government-fill',
    label: 'NYC Public Schools',
    sub: 'Recognized Master Educator',
    color: 'text-emerald-600',
    bg: 'bg-emerald-50',
    border: 'border-emerald-200',
  },
  {
    icon: 'ri-star-fill',
    label: 'Best Math Teacher',
    sub: 'New York City — Community Award',
    color: 'text-orange-500',
    bg: 'bg-orange-50',
    border: 'border-orange-200',
  },
  {
    icon: 'ri-medal-fill',
    label: '30+ Years Excellence',
    sub: 'NYC High School Mathematics',
    color: 'text-teal-600',
    bg: 'bg-teal-50',
    border: 'border-teal-200',
  },
];

export default function FeaturedIn() {
  const [imgError, setImgError] = useState(false);

  return (
    <section className="py-20 px-6 bg-white border-t border-b border-gray-100">
      <div className="max-w-7xl mx-auto">

        {/* Section Label */}
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-2 bg-gray-100 text-gray-500 text-xs font-semibold tracking-widest uppercase px-5 py-2 rounded-full mb-5">
            <i className="ri-newspaper-line text-base"></i>
            As Seen In &amp; Recognized By
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Award-Winning Math Education
          </h2>
          <p className="text-lg text-gray-500 max-w-2xl mx-auto">
            Mr. Augustine's teaching excellence has been celebrated by New York City and covered by international press.
          </p>
        </div>

        {/* Main Feature: Photo + Quote */}
        <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl overflow-hidden shadow-2xl mb-14">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            {/* Photo */}
            <div className="relative h-72 lg:h-auto min-h-[320px]">
              {!imgError ? (
                <img
                  src="https://static.readdy.ai/image/14fde9ba81a9738a8aa28fb63948ba18/77c9bdbb3f5df0aa990c300d8967f9ac.jpeg"
                  alt="Mr. Augustine receiving honors in New York"
                  className="w-full h-full object-cover object-top"
                  onError={() => setImgError(true)}
                />
              ) : (
                <div className="w-full h-full bg-gradient-to-br from-emerald-800 to-teal-900 flex items-center justify-center">
                  <i className="ri-user-star-fill text-7xl text-white/30"></i>
                </div>
              )}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent to-gray-900/60 lg:block hidden"></div>
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/60 to-transparent lg:hidden"></div>
              {/* Badge overlay */}
              <div className="absolute top-5 left-5">
                <div className="bg-amber-400 text-gray-900 text-xs font-bold px-3 py-1.5 rounded-full flex items-center gap-1.5 shadow-lg">
                  <i className="ri-trophy-fill text-sm"></i>
                  Chancellor's Honor Award
                </div>
              </div>
            </div>

            {/* Quote & Press */}
            <div className="p-10 lg:p-14 flex flex-col justify-center">
              <div className="w-10 h-10 flex items-center justify-center mb-6">
                <i className="ri-double-quotes-l text-5xl text-emerald-400 leading-none"></i>
              </div>
              <blockquote className="text-white text-xl lg:text-2xl font-light leading-relaxed mb-8 italic">
                "Mr. Augustine sets the gold standard for mathematics education in New York City — a teacher who transforms not just grades, but lives."
              </blockquote>
              <div className="flex items-center gap-3 mb-10">
                <div className="w-10 h-0.5 bg-emerald-400"></div>
                <span className="text-emerald-400 text-sm font-semibold tracking-wide">International Press Coverage</span>
              </div>

              {/* Press logos row */}
              <div className="flex flex-wrap gap-3">
                {pressFeatures.map((p, i) => (
                  <a
                    key={i}
                    href={p.url}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="group flex items-center gap-2.5 bg-white/10 hover:bg-white/20 border border-white/20 hover:border-emerald-400/60 rounded-xl px-4 py-2.5 transition-all duration-200 cursor-pointer"
                  >
                    <div className={`w-8 h-8 flex items-center justify-center rounded-lg bg-gradient-to-br ${p.color} text-white text-xs font-bold flex-shrink-0`}>
                      {p.logo}
                    </div>
                    <div>
                      <p className="text-white text-xs font-semibold leading-tight">{p.outlet}</p>
                      <p className="text-gray-400 text-xs">{p.year}</p>
                    </div>
                    <i className="ri-external-link-line text-gray-400 group-hover:text-emerald-400 text-sm ml-1 transition-colors"></i>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Awards / Certifications Bar */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {awards.map((a, i) => (
            <div
              key={i}
              className={`${a.bg} border ${a.border} rounded-2xl p-6 flex flex-col items-center text-center gap-3 hover:shadow-md transition-shadow duration-200`}
            >
              <div className={`w-12 h-12 flex items-center justify-center`}>
                <i className={`${a.icon} text-3xl ${a.color}`}></i>
              </div>
              <div>
                <p className="font-bold text-gray-900 text-sm leading-tight mb-1">{a.label}</p>
                <p className="text-gray-500 text-xs leading-snug">{a.sub}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Press Headlines Strip */}
        <div className="border border-gray-200 rounded-2xl overflow-hidden">
          <div className="bg-gray-50 px-6 py-3 border-b border-gray-200">
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-widest flex items-center gap-2">
              <i className="ri-newspaper-line"></i>
              Press Headlines
            </p>
          </div>
          <div className="divide-y divide-gray-100">
            {pressFeatures.map((p, i) => (
              <a
                key={i}
                href={p.url}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="flex items-center gap-5 px-6 py-4 hover:bg-gray-50 transition-colors duration-150 group cursor-pointer"
              >
                <div className={`w-10 h-10 flex items-center justify-center rounded-xl bg-gradient-to-br ${p.color} text-white text-sm font-bold flex-shrink-0`}>
                  {p.logo}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-gray-900 font-semibold text-sm group-hover:text-emerald-700 transition-colors truncate">
                    {p.headline}
                  </p>
                  <p className="text-gray-400 text-xs mt-0.5">{p.outlet} · {p.year}</p>
                </div>
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-arrow-right-line text-gray-300 group-hover:text-emerald-500 text-lg transition-colors"></i>
                </div>
              </a>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
